import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { withCors } from "~/config/cors";
import { PRODUCT_NAME } from "~/lib/env.shared";
import { pageMeta } from "~/utils/meta";
import ConvertAnonymousAccount from "~/pages/ConvertAnonymousAccount";

export const meta = pageMeta(
    `Link Account - ${PRODUCT_NAME}`,
    "Link your anonymous account to a permanent account",
);

export const loader: LoaderFunction = withCors(async ({ request }) => json({}));

export default function LinkAccountRoute() {
    return <ConvertAnonymousAccount />;
}
